export default {
  title: {
    login: "%{school} - Вхід",
    registration: "%{school} - Зареєструватися",
    subjects: "%{school} - Вибір предмету",
    subject: "%{school} - Предмет",
    offer: "%{school} - Пропозиція",
    home: "%{school} - Домашня сторінка",
    dictionary: "%{school} - Словник",
    events: "%{school} - Події",
    news: "%{school} - Новини",
    profile: "%{school} - Профіль",
    learn: "%{school} - Навчання",
    pay: "%{school} - Оплата предмету",
    checkInSystem: "Вкажіть ваш Email",
    setPassword: "Вкажіть пароль для входу.",
    createAccount: "Вкажіть/Перевірте дані вашого профілю в системі",
  },
  authCheckEmail: {
    title: "Вкажіть вашу пошту",
    emailCaption: "Електронна адреса",
    continue: "Продовжити",
    or: "або",
  },
  authPassword: {
    title: "Увійдіть у свій акаунт",
    inputCaption: "Пароль",
    placeholder: "Введіть пароль",
    forgot: "Забули пароль?",
    submit: "Увійти",
  },
  authRegistration: {
    title: "Реєстрація акаунту",
    name: "Імʼя",
    phone: "Номер телефону",
    password: "Придумайте пароль",
    confirmPassword: "Повторіть придуманий пароль",
  },
  totalError: "Упс, щось пішло не так!",
  subjectChangeError: "Не вдалося змінити предмет. Спробуйте ще раз або зв'яжіться зі своєю школою.",
  email: "Email",
  personalLink: "Особисте посилання",
  login: "Логін",
  name: "Ім'я",
  firstLastName: "Прізвище та ім'я",
  phone: "Телефон",
  formatPhone: "Номер телефону у форматі 998...", // for leader-online
  aboutMe: "Про мене",
  fullAge: "Ваш вік (повних років)",
  errorAge: "некоректний вік",
  notNumber: "значення має бути числом",
  registration: "Зареєструватися",
  password: "Пароль",
  currentPassword: "Поточний пароль",
  newPassword: "Новий пароль",
  confirmPassword: "Повторіть пароль",
  confirmNewPassword: "Повторіть новий пароль",
  forgotPassword: "Забули пароль?",
  passwordsMatch: "Паролі не співпадають",
  resetPassword: "Пароль скинуто, перевірте свій Email.",
  resetConfirm: "Ви хочете скинути пароль?",
  enter: "Увійти",
  studentEnter: "Вхід для учнів",
  check: "Далі",
  signInWithGoogle: "Увійти через Google",
  emailIsNotRegistered: "Користувача з цією адресою не існує",
  logout: "Вийти",
  online: "онлайн",
  offline: "офлайн",
  cancel: "Скасувати",
  yes: "Так",
  no: "Ні",
  course: "Курс",
  dictionary: "Словник",
  events: "Події",
  news: "Новини",
  words: "Слова",
  wordsAreHere: "Ці слова знаходяться тут:",
  allWords: "Всі слова",
  phrases: "Фрази",
  videos: "Відео",
  exercises: "Вправи",
  theory: "Теорія",
  theoryAlt: "Конспект",
  theoryAdditionalFile: "Завантажити додатковий файл (%{filename})",
  topic: "Тема",
  lesson: "Урок",
  lessons: "Уроки",
  profile: "Профіль",
  orders: "Покупки",
  payment: "Платежі",
  leaderboard: "Лідери",
  leaderboardPerDay: "Лідери за сьогодні",
  time: "Час",
  points: "Бали",
  myPoints: "Мої бали за весь період",
  coins: "Монети",
  courses: "Мої курси",
  loading: "Завантаження...",
  noTheory: "До цього уроку немає теорії.",
  startTraining: "Почати тренування",
  chat: {
    // === chat list / dialog additions ===
    startDialogTitle: "Почати чат",
    startDialogTooltip: "Створити новий діалог",
    messages: "Повідомлення",
    unreadOnly: "Тільки непрочитані",
    delete: "Видалити",
    send: "Відправити",
    sendHelper: "Ctrl+Enter - для відправки повідомлення",
    close: "Закрити",
    profile: "Профіль",
    lastActivity: "Остання активність",
    status: "Статус",
    jobTitle: "Назва посади",
    tabLabel: "Чат",
    lastOnline: {
      time: "Був онлайн о %{date}",
      weekday: "Був онлайн у %{date}",
      dayMonth: "Був онлайн %{date}",
      monthYear: "Був онлайн у %{date}",
    },
    read: "Прочитано",
    errors: {
      wrongFormatting: "Повідомлення містить неправильне форматування",
    },
  },
  branches: "Теми",
  easy: "Легко",
  expert: "Експерт",
  wordToLearn: "Вивчити пізніше",
  iKnowWord: "Я знаю це слово",
  videoVocabulary: "Відео лексика",
  markVideoWatched: "Позначити як переглянуте",
  videoWatched: "Переглянуто",
  passed: "пройдено",
  unsupportedExercise: "Цей тип вправ (%{type}) ще не підтримується",
  changeCourse: "Змінити курс",
  currentCourse: "Поточний курс",
  allSubjects: "Всі предмети",
  all: "Всі",
  subject: "Предмет",
  group: "Група",
  start: "Розпочати",
  chooseSubject: "Виберіть предмет, який потрібно вивчити",
  hourValue: "%{value} г",
  completed: "Завершений",
  notCompleted: "Не завершений",
  paidBranch: "Платна тема. Для доступу потрібна оплата.",
  buyBranch: "Купити тему за %{price} %{currency}",
  paidSubject: "Платний предмет. Для доступу потрібна оплата.",
  buySubject2: "Купити предмет за %{price} %{currency}",
  decksItemNotOpen: "Щоб відкрити цей урок, вам потрібно виконати попередній урок",
  decksItemNotPurchasedBranch: "Тему цього уроку ще не куплено",
  decksItemNotOpenLevel: "Для відкриття цього уроку, необхідно пройти попередній рівень",
  decksItemNotOpenBranch: "Щоб відкрити цей урок, вам потрібно пройти попередню тему",
  deckAccessDenied: "Цей урок ще не доступний для вас",
  openOnDate: "відкриється %{date}",
  levelAccessIsDenied: "Матеріали цього рівня не доступні для вас",
  youAreDeactivated: "Ваш акаунт було деактивовано, будь ласка, зв'яжіться з вашою школою",
  lockText: {
    p1: "Упс … На жаль, ви не можете отримати доступ до навчальних матеріалів. Роботу школи тимчасово призупинено.",
    p2: "Для детальної інформації та вирішення наявних питань звʼяжіться з представниками школи.",
  },
  youAreDeactivatedShort: "Ваш акаунт деактивовано",
  youAreHaveNotPaidOffers: "У вас є неоплачені пропозиції",
  yourCertificates: "Ваші сертифікати",
  emptyDeck: "Урок порожній",
  nextDeck: "Наступний урок",
  next: "Далі",
  proceed: "Продовжити",
  skip: "Пропустити",
  more: "Більше",
  exit: "Вихід",
  details: "Детальніше",
  go: "Перейти",
  profileEdit: "Редагувати профіль",
  userInfo: "Інформація про користувача",
  of: "з",
  back: "Назад",
  levelPackExist: "У вас вже є цей набір рівнів",
  awaitingPayment: "Чекає на оплату",
  bought: "Куплений",
  boughtUntilDate: "Куплений до %{endDate}",
  availableUntilDate: "Доступний до %{endDate}",
  showMore: "показати більше",
  hide: "згорнути",
  communication: "Зв'язок зі школою",
  askQuestion: "Поставити питання",
  noDescription: "Опис відсутній",
  description: "Опис:",
  onePerMonth: "Підписатись на місяць",
  semiannually: "Підписатись на пів року",
  onceAYear: "Підписатись на рік",
  stopSubscribe: "Зупинити підписку",
  enable: "Увімкнути підписку",
  expired: "Вийшли строки",
  buySubject: "Купити предмет",
  buyOffer: "Купити",
  subscribeOffer: "Підписатись",
  firstPayment: "Перший платіж",
  accessDaysWarning: "Залишився %{smart_count} день |||| Залишилось %{smart_count} днів",
  accessDemoDaysWarning: "Демо: Залишився %{smart_count} день |||| Демо: Залишилось %{smart_count} днів",
  accessDemoButton: "Демо доступ",
  closeButton: "Закрити",
  existOffer: "Вже існує неоплачена пропозиція",
  loginInProcess: "Виконується вхід...",
  done: "Виконано:",
  Levels: {
    empty: "У цьому курсі поки немає доступних рівнів",
    name: "Рівень:",
  },
  Decks: {
    scormPass: "Зарахувати урок",
    proceed: "Далі",
    stayHere: "Залишитись тут",
  },
  Exercises: {
    tabTitle: "Вправи",
    skip: "Далі",
    check: "Перевірити",
    examCheck: "Відправити",
    typeAnswer: "Введіть відповідь",
    next: "Далі",
    rightAnswerWas: "Правильна відповідь була:",
    showRightAnswer: "Показати правильну відповідь",
    rightAnswer: "Правильна відповідь:",
    congratulation: "Поздоровляємо!",
    congratText: "Ви вивчили всі вправи у цьому уроці!",
    wrongAnswer: "Ваша відповідь помилкова",
    answerSaved: "Відповідь збережена",
    commentToAnswer: "Коментар до обранї відповіді:",
    appendix: {
      pdf: {
        tooltipButton: "Додаткові матеріали",
      },
    },
    type13: {
      title: "Заповніть пропуски, вибравши потрібне слово з випадаючого списку",
    },
    type12: {
      title: "Ознайомтесь з додатковою інформацією",
    },
    type11: {
      title: {
        select: "Виберіть правильну відповідь",
        keyboard: "Напишіть правильну відповідь",
      },
    },
    type9: {
      title: {
        select: "Заповніть пропуски, вибравши потрібне слово",
        keyboard: "Заповніть пропуски",
      },
    },
    type8: {
      title: "Знайти відповідність",
    },
    type7: {
      title: {
        text: "Напишіть вашу відповідь",
        audio: "Запишіть аудіо відповідь ",
      },
      recordingIsNotSupported: "Запис звуку не підтримується вашим браузером.",
      audioRecordingError: "Помилка запису звуку: ",
      inputLabel: "Ваша відповідь",
      addPhotoVideo: "Додати фото/відео (до %{maxCount} шт.)",
      addPhoto: "Додати фото (до %{maxCount} шт.)",
      cameraInitialization: "Ініціалізація ...",
      change: "Змінити",
      codeToApprove: "Пароль",
      homework: {
        teacherData: {
          audio: "Аудіо коментар вчителя",
          audioComment: "Голосовий коментар вчителя",
        },
      },
      addFiles: "Додати файли",
      limitsHelperText: "Довжина тексту має бути не менше %{count} літер",
      photoRequired: "Додайте хоча б одне фото або файл до вашої відповіді",
      photoViewerHint: "Зображення можна масштабувати колесом миші",
    },
    type6: {
      title: "Намалюйте елемент",
      checkButtonText: "Зрозуміло!",
    },
    type3: {
      title: "Розташуйте тут елементи у правильному порядку",
      hint: "Перетягніть сюди елементи, розташовані нижче",
    },
    type5: {
      title: "Виберіть елементи",
      hint: "Виберіть потрібні елементи у нижній частині екрана (щоб вибрати - просто натисніть на них)",
    },
    type2: {
      title: "Виберіть пропущене слово",
    },
  },
  Events: {
    headNotice: "Час події відображається відповідно до вашого часового поясу",
    title: "Події цього тижня",
    startTime: "Час початку",
    finishTime: "Час закінчення",
    group: "Група",
    persons: "%{smart_count} учня |||| %{smart_count} учнів",
    leader: "Ведучий",
    tag: "Категорія",
    joinedCheckbox: "З реєстрацією",
    joined: "Обрано:",
    interested: "Зареєструватися",
    registered: "Зареєстровано",
    enter: "Увійти",
    limitPopupInfo: "Ви досягли ліміту реєстрацій на події",
    eventHasStarted: "Подія вже почалася!",
    registrationNotice: "Ви успішно зареєструвалися! Кнопка входу буде активна у %{date_and_time}. Після цього часу ви не зможете скасувати реєстрацію на подію",
    registrationNoticeNoUrl: "Ви успішно зареєструвалися! Після %{date_and_time} ви не зможете скасувати реєстрацію на подію",
    cancelRegistration: "Ви дійсно хочете скасувати реєстрацію?",
    calendarLink: "Додати подію у Google календар",
    status_planned: "Заплановано",
    status_started: "Розпочато",
    status_completed_successfully: "Завершено",
    status_last_minute_cancellation: "Скасовано в останній момент",
    status_late_cancellation: "Пізнє скасування",
    status_canceled: "Скасовано",
    status_moved: "Перенесено",
  },
  statistic: {
    title: "Статистика",
    points: "Бали",
    phrases: "Фрази",
    missions: "Місії",
    words: "Слова",
    time: "Час",
  },
  status: {
    wait_review: "Чекає перевірки",
    on_review: "В процесі",
    approved: "Прийнято",
    not_approved: "Відхилено",
    not_approved_allow_update: "Відхилено (дозволено виправити)",
    ai_reviewed: "Перевірено за допомогою ШІ",
  },
  homeworks: {
    tabName: "Завдання",
    todo: "До виконання",
    done: "Виконані",
    topic: "Тема",
    lesson: "Урок",
    onlyInMobileApp: "Доступно лише в мобільному додатку",
    todoHomework: "ЗАВДАННЯ НА ПЕРЕВІРЦІ",
    postToDoButton: "Відправити",
    types: {
      homework_todo: "ToDo",
      exercise: "Вправа",
    },
    waitAIReview: "Зачекайте, ШI перевіряє відповідь",
    dontWait: "не чекати",
    checkingHomework: "Перевіряю домашнє завдання",
  },
  exam: {
    popupTitle: "Урок з іспитом",
    popupDescr1: "Це урок із іспитом. Спочатку вивчіть всі додаткові матеріали, і лише після цього переходьте до виконання вправ.",
    popupDescr2: `Як тільки ви перейдете у вкладку "Вправи", почнеться відлік часу.`,
    popupDescr3: 'Вкладки "Теорiя" та "Відео" НЕ запускають відлік часу іспиту.',
    cancelButton: "Наступного разу",
    positiveButton: "Зрозуміло (%{smart_count} спроба)  |||| Зрозуміло (%{smart_count} спроби)",
    questions: "%{smart_count} питання |||| %{smart_count} питань",
    oneAttempt: "Одна спроба на відповідь",
    timeLimit: "Обмеження часу: %{limit} хвилин",
    noPause: "Іспит не може бути призупинено",
    progress: "Питання №%{current} з %{total}",
    closeButton: "Закрити",
    viewButton: "Переглянути результати",
    retakeButton: "Спробувати знову (%{smart_count} спроба)  |||| Спробувати знову (%{smart_count} спроби)",
    finishedPopupTitle: "Результати іспиту",
    examPassed: "Іспит складено успішно",
    examNotPassed: "Іспит не складено",
    waitHomeworks: "%{smart_count} питання на перевірці |||| %{smart_count} питань на перевірці",
    result: "Ваш результат:",
  },
  subjects: {
    unavailable: "На даний момент предмет недоступний",
  },
  orderStatus: {
    approved: "Успішно",
    canceled: "Скасовано",
    pending: "Очікує",
  },
  notificationsTypes: {
    event: "Подія",
    invoice: "invoice",
    news: "Новина",
    homework: "Завдання",
    homework_todo: "Завдання Todo",
    type: {
      exercise: "Завдання",
      homework_todo: "Завдання To do",
    },
  },
  notificationsAlert: {
    subscribe: "Увімкнути сповіщення",
    unsubscribe: "Вимкнути сповіщення",
    instructions: "Натисніть на замочок 🔒 зліва від адресного рядка і змініть дозвіл повідомлень, як показано на зображенні, або змініть загальні налаштування браузера.",
    permissionDefault: {
      title: "Підпишіться на сповіщення 🔔",
      body: "Сповіщення про зміну статусу ДЗ, початок події, новини, нове завдання до виконання. Ніякої реклами, тільки повідомлення про ваше навчання!",
    },
    permissionDenied: {
      title: "Зараз сповіщення вимкнені ❌",
      body: "Раніше ви відмовилися від повідомлень. Без них ви не можете вчасно дізнаватися про зміну статусу ДЗ, початок події. Щоб увімкнути сповіщення дотримуйтесь інструкцій нижче:",
    },
    permissionGranted: {
      title: "Зараз сповіщення увімкнено ✔",
      body: "Ви точно хочете відмовитися від сповіщень? Без них ви не можете вчасно дізнаватися про зміну статусу ДЗ, початок події. Щоб вимкнути сповіщення дотримуйтесь інструкцій нижче:",
    },
  },
  feedbackDialog: {
    sendFeedback: "Надіслати відгук",
    placeholder: "Розкажіть про ваші враження",
    defaultInstruction: "Використовуйте слайдер щоб оцінити",
    eventInstruction: "Оцініть як пройшла подія",
    submitError: "Виберіть будьласка оцінку",
    submitSuccess: "Дякуємо! Ваш відгук успішно відправлено",
    wasNotPresent: "Я не відвідував подію",
    dateOfEvent: "Дата події:",
  },
  congratulation: {
    mission: "Вітаємо, місію %{name} завершено!",
    missionTask: {
      title: "🎉 Вітаємо! Задача %{name} виконана.",
      content: "До завершення місії залишилось <b>%{need} задач</b> — продовжуй у тому ж дусі!",
    },
  },
  accountNotFound: "Ця адреса електронної пошти не повʼязана з жодним освітнім простором. Звʼяжіться з адміністратором вашої школи",
  demoAccess: "Бажаєте спробувати SkillzRun для свого бізнесу/школи? Зареєструйтеся для тестування платформи",
  structure: "Структура",
  version: {
    message: "Нова версія застосунку доступна. Перезавантажте сторінку, щоб оновити",
    button: "Перезавантажити",
  },
  missions: {
    title: "Місії",
    startButton: "Старт місії",
    missionStarted: "Місію розпочато %{started}",
    started: "Місія розпочалася!",
    tasks: {
      title: "Деталі завдання",
    },
  },
  productCatalog: {
    title: "Каталог продукції",
    coinBalance: "Ваш баланс:",
    notEnoughCoins: "Недостатньо монет",
    order: "Замовити",
    orderConfirmation: "Підтвердження замовлення",
    price: "Ціна:",
    remaining: "Залишок:",
    instructionForForm: "Щоб прискорити обробку вашого замовлення заповніть дані для отримання",
    address: "Адреса",
    thankText: "Дякуємо! Ваше замовлення оформлено",
    pleaseWait: "Очікуйте, з вами звʼяжеться менеджер",
    pleaseWaitPersona: "Очікуйте на СМС, вам надійде ТТН",
    thankTextOffer: "Дякуємо! Покупку оформлено",
    contentAvailableText: "Контент уже доступний — можете користуватись прямо зараз.",
    deliveryAddress: "Введіть адресу доставки",
    helperText: "Вкажіть повну адресу або місто та номер відділення Нової пошти/Укрпошти",
    deliveryOptions: "*Варіанти доставки будуть уточнені з менеджером після отримання замовлення.",
    validationPhoneFormat: "Номер телефону має складатися з 10 цифр і починатися з 0.",
    recipientNameLabel: "ПІБ",
    recipientNameRequired: "Будь ласка, введіть ім'я отримувача.",
    npCityRequired: "Будь ласка, оберіть місто доставки.",
    npWarehouseRequired: "Будь ласка, оберіть відділення Нової пошти.",
    npCityLabel: "Місто Нової пошти",
    npCityPlaceholder: "Почніть вводити назву міста",
    npCitySearching: "Пошук міст...",
    npCitySelectHint: "Оберіть місто зі списку",
    npCityTypeHint: "Почніть вводити назву міста (щонайменше 3 символи)",
    npBranchTypeDepartments: "Відділення",
    npBranchTypePostomats: "Поштомати",
    npWarehouseLabel: "Відділення Нової пошти",
    npWarehousePlaceholder: "Оберіть відділення",
    npWarehouseLoading: "Завантаження відділень...",
    npWarehouseSelectHint: "Оберіть відділення зі списку",
    npWarehouseEmpty: "Для цього міста відділення не знайдено",
    npWarehouseCityFirst: "Спочатку оберіть місто",
    inProcessing: "В обробці",
    purchased: "Придбано",
    oneTimeAlreadyPurchased: "Цей товар уже придбаний",
  },
  companyReviewTitle: "Наскільки ймовірно, що ви порекомендуєте нашу школу другу чи знайомому?",
  companyReviewText: 'Оцініть за шкалою від 1 до 10, де 1 означає "зовсім не ймовірно", а 10 - "дуже ймовірно"',
  subjectReviewTitle: "Наскільки вам було цікаво проходити цей курс на платформі",
  subjectReviewText: 'Оцініть за шкалою від 1 до 10, де 1 означає "зовсім не цікаво", а 10 - "дуже цікаво"',
  lessonsCount_one: "%{smart_count} урок",
  lessonsCount_few: "%{smart_count} уроки",
  lessonsCount_many: "%{smart_count} уроків",
  policySettings: {
    termsAndConditions: "Правила та умови",
    refund: "Політика конфіденційності",
  },
  promoCode: "Промокод",
  promoInvalid: "Промокод недійсний",
};
